import { parse } from 'iso8601-duration';
import { Duration } from "../models";

const parseToDuration = (iso8601Duration: string): Duration => {
    return parse(iso8601Duration);
}

export default parseToDuration;